













import { Component, Vue, Prop } from 'vue-property-decorator';
import { ELTABLE_FORMAT } from '@/utils/elTable_formatter';
import { TableColumn } from 'element-ui/types/table-column.d';
@Component<NumberColumn>({
    name: 'NumberColumn',
})
export default class NumberColumn extends Vue {
    @Prop({ required: true, type: String }) private prop!: string;
    @Prop({ required: true, type: String }) private label!: string;
    @Prop({ type: String, default: 'right' }) private align!: string;
    @Prop({ type: [String, Number], default: '' }) private width!: number | string;
    @Prop({ type: [String, Number], default: 130 }) private minWidth!: number | string;
    @Prop({ type: Boolean, default: false }) private fixed!: boolean;
    @Prop({ type: [Boolean, String], default: false }) private sortable!: boolean | string;
    @Prop({ type: String, default: '' }) private unit!: string;
    
    @Prop({ type: Boolean, default: false}) private onlyPositive!: boolean;
    @Prop({ type: Boolean, default: false}) private specificZero!: boolean;
    @Prop({ type: String, default: ''}) private zeroText!: string;
    private formatter: (row: any, column: TableColumn) => string = (row: any, column: TableColumn) => {
        if (this.specificZero && row[column.property] === 0) {
            return this.zeroText;
        }
        return (
            row[column.property] !== undefined ?
                (this.onlyPositive && row[column.property] < 0 ? '-' : ELTABLE_FORMAT.NumberFormat(row, column))
                : '-'
        ) + (this.unit === '' ? '' : ' ' + this.unit);
    }
}
